export default __webpack_public_path__ + "static/media/centrifuge-top-empty.298fdab0.svg";